import store from '../store/store'
import { appDownloadURL } from '../config/index'
// 判断平台
const checkPlatform = function () {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad)/i))) {
    return 'iOS'
  } else if ((navigator.userAgent.match(/(Android|Linux)/i))) {
    return 'Android'
  } else {
    return 'PC'
  }
}

function getCharCount(str, char) {
  let reg = new RegExp(char, 'g');
  let result = str.match(reg);
  let count = !result ? 0 : result.length;
  return count;
}

export default {
  /* 因为微信分享会增加参数的原因 */
  /* #会截断url.search */
  getUrlParams(key) {
    let url = window.location.href;
    let after = "";
    let arr = [];
    let result = {}
    if (url.indexOf('?') === -1) {
      return null
    } else if (getCharCount(url, '\\?') == 1) {
      after = url.substring(url.indexOf('?') + 1)
      // console.log('getUrlParams 1 after', after)
    } else if (getCharCount(url, '\\?') == 2) {
      after = window.location.hash;
      after = after.split("?")[1];
      // console.log('getUrlParams 2 after', after)
    }
    if (after) {
      arr = after.split("&");
      arr.forEach(item => {
        result[item.split("=")[0]] = item.split("=")[1]
      })
      // console.log("getUrlParams result", result)
      return result[key]
    }
  },
  getRemSize() {
    let w = window.innerWidth || window.screen.availWidth;
    if (w) {
      let a = w * 50 / 375 > 55.2 ? 55.2 : w * 50 / 375;
      document.getElementsByTagName('html')[0].style.fontSize = a + 'px';
    } else {
      document.getElementsByTagName('html')[0].style.fontSize = 50 + 'px';
    }
  },
  genQuery(obj) {
    let str = "";
    for (let key in obj) {
      str += `${key}=${obj[key]}&`;
    }
    str = `?${str}`;
    return str.substring(0, str.length - 1);
  },
  checkPlatform: checkPlatform
}

export const newGuid = () => {
  var guid = "";
  for (var i = 1; i <= 32; i++) {
    var n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    // if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
    //   guid += "-";
  }
  return guid;
};

/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export const debounce = (func, wait, immediate) => {
  let timeout;

  return function () {
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
  }
}

export const isPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
  }
  return flag;
}

export const isWechat = () => {
  let agent = window.navigator.userAgent.toLowerCase();
  if (agent.match(/MicroMessenger/i) == "micromessenger" || agent.match(/mobile Mqqbrowser/i) == "mobile mqqbrowser") return true;
  return false;
}

export const isApp = () => {
  let agent = window.navigator.userAgent.toLowerCase();
  if (agent.indexOf("chuangqi") > -1 || window.ReactNativeWebView) return true;
  return false;
}

export const launchApp = () => {
  /* 
    1、downloadUrl：app下载地址
    2、targetUrl： app内页地址
    3、org_id：组织机构id
    */
  let downloadUrl = store.state.voteInfo.app_download_url;
  // 12345特殊处理
  if (store.state.voteInfo.org_id == 409) {
    downloadUrl = `https://12345.linyi.gov.cn/download/index.html`
  }
  let targetUrl = store.state.voteInfo.url;
  let title = store.state.voteInfo.title;
  let org_id = store.state.voteInfo.org_id;
  let json = JSON.stringify({
    opentype: "web",
    title: title,
    // body: "https://app-vs.iqilu.com/vote/#/vote?id=21"
    param: targetUrl,
  });
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  let iFrame;
  if (isAndroid) {
    // 安卓 app 的 scheme 协议
    iFrame = document.createElement("iframe");
    iFrame.setAttribute(
      "src",
      "chuangqi" + org_id + "://local?entry=" + encodeURIComponent(json)
    );
    iFrame.setAttribute("style", "display:none;");
    iFrame.setAttribute("height", "0px");
    iFrame.setAttribute("width", "0px");
    iFrame.setAttribute("frameborder", "0");
    document.body.appendChild(iFrame);
    iFrame.parentNode.removeChild(iFrame);
    iFrame = null;
    //window.location.href = 'chuangqi1://local?entry=' + encodeURIComponent(json);
    setTimeout(function () {
      let hidden =
        window.document.hidden ||
        window.document.mozHidden ||
        window.document.msHidden ||
        window.document.webkitHidden;
      if (typeof hidden == "undefined" || hidden == false) {
        //下载地址
        window.location.href = downloadUrl;
      }
    }, 2500);
  } else if (isIOS) {
    // ios 的 scheme 协议
    window.location.href =
      "chuangqi" + org_id + "://local?entry=" + encodeURIComponent(json);
    setTimeout(function () {
      let hidden =
        window.document.hidden ||
        window.document.mozHidden ||
        window.document.msHidden ||
        window.document.webkitHidden;
      if (typeof hidden == "undefined" || hidden == false) {
        //下载地址
        window.location.href = downloadUrl;
      }
    }, 2500);
    return false;
  } else {
    window.location.href = downloadUrl;
  }
}

export const launchAppOLLLLD = () => {
  window.location.href = appDownloadURL + store.state.voteInfo.org_id
}

export const launchAppSD = () => {
  const url = store.state.voteInfo.url;
  const u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    const schemaUri = `https://a.app.qq.com/o/simple.jsp?pkgname=com.iqilu.ksd&ckey=&android_schema=${encodeURIComponent(`sdxw://platformapi/startapp?entry=${encodeURIComponent(JSON.stringify({ "opentype": "webapp", "param": `${url}` }))}`)}`;
    if (u.match(/MicroMessenger\/[0-9]/i) || u.match(/QQ\/[0-9]/i)) {
      window.location.href = `https://ksdshare.iqilu.com/share/download#${encodeURIComponent(schemaUri)}`
    } else {
      window.location.href = schemaUri
    }
  } else {
    window.location.href = `https://ksdshare.iqilu.com/share/download/?entry=${encodeURIComponent(JSON.stringify({ "opentype": "webapp", "param": `${url}` }))}`
  }
}

export const getSpeToken = () => {
  // const urlString = 'http://295.api.votesignup.test.qiludev.com/votes/?id=Mjk1OjQxNGQ1&type=0&__SHARE__=1&orgid=29&__token__=573b9994cfe645f7be0119b5b715593e-108301734#/vote?id=Mjk1OjQxNGQ1&active=0&type=0&orgid=29'
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return params.get('__token__');
}
